import React from 'react';
import { CustomButton } from '../../../components';
import { Box, SvgIcon, Typography } from '@mui/material';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

interface IProps {
  handleFinishInterview: (e: React.SyntheticEvent | null) => void;
}

const FinishInterviewButton: React.FC<IProps> = ({ handleFinishInterview }) => {
  return (
    <>
      <Box
        sx={(theme) => ({
          width: 511,
          position: 'relative',
          ['@media (max-width: 1200px)']: {
            width: '100%',
          },
          [theme.breakpoints.down('md')]: {
            width: 400,
          },
          ['@media (max-width: 400px)']: {
            width: '100%',
          },
        })}
      >
        <Box
          sx={{
            position: 'absolute',
            zIndex: 1,
            color: 'white',
            top: '46%',
            transform: 'translateY(-50%)',
            left: '26px',
          }}
        >
          <Typography variant="body2">Done?</Typography>
        </Box>
        <CustomButton
          label="Finish interview"
          startIcon={
            <SvgIcon inheritViewBox component={PlaylistAddCheckIcon} />
          }
          fullWidth
          onClick={handleFinishInterview}
          color="primary"
        />
      </Box>
    </>
  );
};

export default FinishInterviewButton;
